export type IErrorModel<T> = {
    [Property in keyof T]?: string[]
};

export class ErrorModel<T> extends Error {
  public content: IErrorModel<T>;

  constructor(message: string, content: IErrorModel<T>) {
    super(message);
    this.content = content;
  }

  static isErrorModel = <T1>(obj: any): obj is ErrorModel<T1> => typeof obj.content === 'object';
}
